module.exports = __webpack_public_path__ + "img/baizhi-back-four.fd37427c.jpg";